import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import React from 'react';
import 'dayjs/locale/nl';

import { InputRenderer } from '../types';

const DateInput = ({ inputProps: { name, onChange, value: rawValue }, required, size }: InputRenderer) => {
  const [value, setValue] = React.useState<Dayjs | null>(rawValue ? dayjs(rawValue) : null);

  return (
    <LocalizationProvider adapterLocale="nl" dateAdapter={AdapterDayjs}>
      <DatePicker
        name={name}
        slotProps={{
          field: { clearable: !required },
          textField: { required, size },
          openPickerButton: { 'aria-label': `Choose date for ${name}` },
        }}
        value={value}
        onChange={(newValue) => {
          setValue(newValue);
          onChange({ target: { value: newValue } });
        }}
      />
    </LocalizationProvider>
  );
};

export default DateInput;
